






































































































import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import * as Dynamsoft from 'dynamsoft-barcode-reader-bundle';

@Component
export default class BarcodeDialog extends Vue {


  public showInternal = false;
  public mode: Common.InspectionModes = Common.InspectionModes.shipping; //検品モードの初期値を出荷検品に変更
  public deliveryDateLabel :string = '出荷日';  // 検品モードの初期値（出荷検品）に対応するラベルを設定
  public voucherNo:string = null; //検品対象の伝票(伝票選択モードではnull)
  public showItems :boolean =false //明細表示モード
  public inspectionModes = Common.InspectionModes;
  public cameraEnabled:boolean;

  public async show(){

    // showDeliveryDateToDayをキャッシュから取得。無い場合初期値はfalse
    this.showDeliveryDateToDay = localStorage.showDeliveryDateToDay ? localStorage.showDeliveryDateToDay == "true" : false;
    // ***** スマホ検品ボタン押下確認 *****
    this.$api.issueGA4trackevent(this.$route.path,'【スマホ検品】ボタン押下');
    //毎回初期化する(ライセンスの状況が同じとは限らない)
    await navigator.mediaDevices.enumerateDevices().then(devices =>{
      //カメラデバイスがあり検品デバイス数が設定されている場合にカメラゾーンを有効化する
      this.cameraEnabled = devices.filter((device) => device.kind === 'videoinput').length > 0 && this.$api.license.hasScannerLicense;
    });    

    //ロードしておかないと鳴らない
    (this.$refs.progress as HTMLAudioElement).load();
    (this.$refs.success as HTMLAudioElement).load();
    (this.$refs.error as HTMLAudioElement).load();
    this.$root.$emit('bv::hide::tooltip');    
    // console.log('test1');
    // navigator.mediaDevices.getUserMedia(null).then(()=>{console.log('found');}).catch(error => console.log('error'));
    // console.log('test2');
    //アンドロイドで不具合が発生するのでコメントアウト
    // navigator.mediaDevices.getUserMedia({ audio: false, video: true }).then(stream => console.log(JSON.stringify(stream.getVideoTracks()[0].getCapabilities())));

    if (this.$api.tenantSettings.inspectionMode == Common.InspectionModes.none){
      this.$api.modal.show('無効な操作','「システム設定」 > 「テナント設定」でスマホ検品を有効にしてください。',true,null);
      return;
    }

    
    this.validateLicense().then(()=>{
      this.showInternal = true;
      this.startScan();

    //初期モード
    if ((this.$api.tenantSettings.inspectionMode & this.mode) == 0) {
      if ((this.$api.tenantSettings.inspectionMode & Common.InspectionModes.picking) > 0) this.mode = Common.InspectionModes.picking;
      else if ((this.$api.tenantSettings.inspectionMode & Common.InspectionModes.shipping) > 0) this.mode = Common.InspectionModes.shipping;
      else if ((this.$api.tenantSettings.inspectionMode & Common.InspectionModes.receipt) > 0) this.mode = Common.InspectionModes.receipt;
      else if ((this.$api.tenantSettings.inspectionMode & Common.InspectionModes.stock) > 0) this.mode = Common.InspectionModes.stock;    
    } else {
      this.loadVoucher();
    }      
      (window as any).Intercom('update', {"hide_default_launcher": true});      
    });
  }
  public close(){
    this.closeScan();
    this.showInternal = false;
      (window as any).Intercom('update', {"hide_default_launcher": false});      
  }

 //------------ エラー管理 ---------------
 public suspended:boolean =false;
 public mounted(){
    this.$root.$on('bv::modal::show', this.suspendDialog);
    this.$api.formatter.ensureListLoaded('userGroup');
 }
public unmounted(){
    this.$root.$off('bv::modal::show', this.suspendDialog);
}
public suspendDialog(bvModalEvent :any, modalId:any){
  //エラーダイアログが表示された場合に一旦閉じる
  if (bvModalEvent  && bvModalEvent .target.id != 'barcode-dialog' && this.suspended == false) {
    this.suspended = true;
    this.showInternal = false;
  }
}

public reopenDialog(error :any){
  //ライセンスエラー以外の場合は、再オープンする
  this.suspended = false;
  //強制終了は廃止。また子画面は閉じていないので何もする必要なし。
  // if (error.response && error.response.data && error.response.data.message){
  //     if ((error.response.data.message as String).startsWith('[ライセンスエラー]')) this.close();
  //     else this.showItems = true;
  // }
}

  //-----------  スキャナ管理 ------------  

  public isLoading: boolean = true;
  public message: string = null;
  // public get token():string{
  //   return localStorage.barcodeLicense;
  // }
  // public set token(value:string){
  //   localStorage.barcodeLicense = value;
  // }  
  public scannerElm: HTMLElement = null;
  public pScanner:Dynamsoft.BarcodeScanner = null;

  // public created(){
  //   if (! BarcodeReader.license){
  //     BarcodeReader.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMTU4MDkzLVRYbFhaV0pRY205cSIsIm9yZ2FuaXphdGlvbklEIjoiMTAxMTU4MDkzIn0=';      
  //     BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@9.0.2/dist/";
  //   }
  // }
  
  async beforeDestroy() {
    this.closeScan();
  }
  public async validateLicense(){
    if (this.cameraEnabled == false) {
      this.isLoading = false;
      return;
    }


    // if (! BarcodeReader.license){
    //   // BarcodeReader.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMTU4MDkzLVRYbFhaV0pRY205cSIsIm9yZ2FuaXphdGlvbklEIjoiMTAxMTU4MDkzIn0=';      
    //   BarcodeReader.license ='DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMTU4MDkzLTEwMTIxNzQzNCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMTE1ODA5MyIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOi0xNjA1MTY5MzQ5fQ==';
    //   BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@9.0.2/dist/";
    // }    
    return this.$api.execute(new Common.BarcodeLicenseValidateQuery(localStorage.barcodeLicense)).then(
      token=>{
        localStorage.barcodeLicense = token;
      }).catch(error=>{
        //ライセンスエラーが発生した場合はスキャナを無効化する
        this.cameraEnabled = false;
        this.isLoading = false;
      });
  }
  public async startScan(){
    if (this.cameraEnabled == false) return;    
    　// デバッグ
      // this.isLoading = false;
      // return ;

      //携帯端末で縦使用するとカメラのwidthとheightが逆転する
      var ua = window.navigator.userAgent.toLowerCase();
      var isVertical = window.innerHeight > window.innerWidth && (ua.indexOf("android") !== -1 || ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1);     

      try{

        const config = {
          license: "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMTU4MDkzLTEwMTIxNzQzNCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMTE1ODA5MyIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOi0xNjA1MTY5MzQ5fQ==", // Replace with your Dynamsoft license key
          container: ".dce-video-container", 
          uiPath: "https://cdn.jsdelivr.net/npm/dynamsoft-barcode-reader-bundle@10.5.3000/dist/",
          scanMode: Dynamsoft.EnumScanMode.SM_MULTI_UNIQUE,
          showResultView: false,
          engineResourcePaths: {
            rootDirectory: "https://cdn.jsdelivr.net/npm/dynamsoft-barcode-reader-bundle@10.5.3000/dist/",
          },
          duplicateForgetTime:2000, //ミリ秒        
          onUniqueBarcodeScanned:  (result: any) => { this.onScan(result.text);},
          removePoweredByMessage: true,  
        }
  
        this.pScanner = new Dynamsoft.BarcodeScanner(config);
        this.pScanner.launch();        
        this.isLoading = false;
        this.$root.$emit('bv::hide::tooltip'); //念のため

      //   let scanner = await barcodescanner.launch();
      //   this.pScanner = scanner;
      //   scanner.setUIElement(document.getElementById("barcodeScannerUI"));
      //   scanner.onUniqueRead = (txt, result) => { this.onScan(txt);};        
      //   scanner.getScanSettings().then((settings)  =>{
      //       settings.whenToPlaySoundforSuccessfulRead = 'unique';
      //       settings.whenToVibrateforSuccessfulRead = 'unique';
      //       settings.duplicateForgetTime = 500; //ミリ秒
      //       settings.intervalTime = 100;//
      //       scanner.updateScanSettings(settings);            
      //   });
      //   scanner.updateVideoSettings({
      //       video: {
      //         aspectRatio: isVertical ? 0.3333: 3,
      //         width:isVertical ? 240 : 720,
      //         height:isVertical ? 720 : 240,
      //         facingMode: 'environment',
      //       }
      //   });        
      //   scanner.onPlayed = async info => {
      //       let precentW = 60;
      //       let precentH = 80;
      //       let rs = await scanner.getRuntimeSettings();
      //       rs.region.regionLeft = (100 - precentW) / 2;
      //       rs.region.regionRight = (100 + precentW) / 2;
      //       rs.region.regionTop = (100 - precentH) / 2;
      //       rs.region.regionBottom = (100 + precentH) / 2;
      //       rs.region.regionMeasuredByPercentage = 1;
      //       await scanner.updateRuntimeSettings(rs);
      //   }        
      //   await scanner.open();
      //   // await scanner.setZoom(400);        
      //   this.isLoading = false;
      //   this.$root.$emit('bv::hide::tooltip'); //念のため
      }
      catch(ex)
      {
        console.error(ex);
        this.$api.modal.show('','検品を行うためのカメラが確認できませんでした。カメラの設定を確認してください。',true,null);
        this.close();
      }
    
  }

  public closeScan(){
    
    if(this.scannerElm) { 
      (this.$refs.target as HTMLElement).removeChild(this.scannerElm);  
      this.scannerElm = null;
    }

    if (this.pScanner) {
      this.pScanner.dispose();
      this.pScanner = null;
      this.message = null;
    }
  }
  
  //スキャン後の動作
  public onScan(barcode:string){

    //対象レコードに移動する
    if (this.showItems){
      this.currentId = this.items.findIndex(value => (value as Common.BarcodeItem).barcode.trim() == barcode); //トリム追加
      //カウントアップする      
      if (this.currentId != -1 && this.autoCountUp) {
        var selected = (this.items[this.currentId] as Common.BarcodeItem);
        selected.scannedQuantity++;
        if (selected.targetQuantity == selected.scannedQuantity)  (this.$refs.success as HTMLAudioElement).play();
        else (this.$refs.progress as HTMLAudioElement).play();    
      }
    } else {
      this.currentId = this.items.findIndex(value => (value as Common.BarcodeVoucher).voucherNo.trim() == barcode); //トリム追加
    }

    if (this.currentId == -1){
      this.message = String.format('【読取結果】レコードが見つかりませんでした({0})',barcode);
      (this.$refs.error as HTMLAudioElement).play();
    } else {
      this.message = String.format('【読取結果】レコードが見つかりました({0})',barcode);
    }
  }

  //-----------  伝票選択モード ------------
  public isDataLoading:boolean = false;
  public originalItems: Common.BarcodeVoucher[];
  public showCompletedVoucher = false;
  public pickingNo:string = null;
  public showDeliveryDateToDay:boolean = false;

  public voucherNoNames = [
      new Common.BindItem(Common.InspectionModes.picking, 'ピッキング番号'),
      new Common.BindItem(Common.InspectionModes.shipping, '出荷番号'), 
      new Common.BindItem(Common.InspectionModes.receipt, '入荷番号'), 
      new Common.BindItem(Common.InspectionModes.stock, '棚卸処理番号')];
  @Watch('mode')
  public onModeChanged(newValue: Common.InspectionModes, oldValue: Common.InspectionModes){
    //ピッキング=>出荷検品以外の移動でフィルタをリセットする
    if (newValue != Common.InspectionModes.shipping || oldValue != Common.InspectionModes.picking) this.pickingNo = null;
    if (newValue == Common.InspectionModes.picking) this.showCompletedVoucher = true;
    else this.showCompletedVoucher = false;
    // 入出荷日当日を表示するラベル制御
    this.deliveryDateLabel = null;
    if (newValue == Common.InspectionModes.shipping) {
      this.deliveryDateLabel = '出荷日';
    }
    else if (newValue == Common.InspectionModes.receipt) {
      this.deliveryDateLabel = '入荷日';
    }
    this.loadVoucher();
  }

  public loadVoucher(){
    
    this.originalItems = null;
    this.resetSelector();
    this.isDataLoading = true;
    return this.$api.execute(new Common.BarcodeVoucherQuery(this.mode,this.pickingNo,localStorage.barcodeLicense)).then(res => {
      this.originalItems = res ? (res as Common.LoadResult).result : null;
      this.resetItems();  
      this.isDataLoading = false;
      this.message = String.format("{0}をスキャン / 左右ボタン(スワイプ)で選択",this.voucherNoNames.find(entry =>entry.value == this.mode).text);
    }).catch(error =>this.reopenDialog(error));
  
  }
  @Watch('showCompletedVoucher')
  @Watch('showDeliveryDateToDay')
  public resetItems(){
      const isToday = this.showDeliveryDateToDay == true && (this.mode == Common.InspectionModes.shipping || this.mode == Common.InspectionModes.receipt);
      this.items = this.originalItems ? this.originalItems.filter(item =>item.isCompleted == false || this.showCompletedVoucher).filter(item =>isToday==false || item.date.getTime()==new Date().getCalendarDate().getTime()):null; //フィルタする    
      if (this.items && this.items.length > 0) this.currentId = 0;
      else this.currentId = -1;              
      localStorage.showDeliveryDateToDay = this.showDeliveryDateToDay;
      this.onCurrentIdChanged();          
  }
  //検品開始ボタン
  public onStart(){
    this.voucherNo = (this.selected as Common.BarcodeVoucher).voucherNo;
    var warehouseId =  (this.selected as Common.BarcodeVoucher).warehouse.id;
    this.resetSelector();
    this.isDataLoading = true;
    //検品開始で商品明細を取得する

    this.$api.execute(new Common.BarcodeItemQuery(this.mode,this.voucherNo,warehouseId,localStorage.barcodeLicense)).then(res => {
      this.items = (res as Common.LoadResult).result;
      if (this.items && this.items.length > 0) this.currentId = 0;
      else this.currentId = -1;              
      this.onCurrentIdChanged();
      this.showItems = true;
      this.isDataLoading = false;
      this.message = "商品をスキャン / 左右ボタン(スワイプ)で選択"      
    }).catch(error =>this.reopenDialog(error));
  }

  public moveToShipping(){
    this.pickingNo = (this.selected as Common.BarcodeVoucher).voucherNo;
    this.mode = Common.InspectionModes.shipping;
  }

  //キャンセルボタン
  public onCancel(){
    this.close();
  }

  //-----------  商品明細モード ------------

  public autoCountUp: boolean = true;
  public get isVoucherCompleted(){
    return  (this.items as Common.BarcodeItem[]).filter(obj =>obj.isCompleted == false).length == 0;

  }

  //検品完了ボタン
  public onItemsOk(){

    //検品結果をコミットする
    this.$api.execute(new Common.BarcodeItemUpdateQuery(this.mode,this.voucherNo, this.items as Common.BarcodeItem[],localStorage.barcodeLicense)).then(()=>
    {
      this.showItems = false;    
      this.voucherNo = null;    
      this.loadVoucher();  
    }).catch(error =>this.reopenDialog(error));
  }

  //キャンセルボタン
  public onItemsCancel(){
    this.showItems = false;    
    this.voucherNo = null;    
    this.loadVoucher();
  }

  
  //-----------  レコードセレクタ(共通) ------------

  public items:Array<Common.BarcodeItem | Common.BarcodeVoucher> = null; 
  public selected : Common.BarcodeItem | Common.BarcodeVoucher = null;
  public currentId:number = -1;

  public resetSelector(){
    this.items = null;
    this.currentId = -1;
    this.selected = null;    
  }  

  @Watch('currentId')
  public onCurrentIdChanged(){
    if (this.currentId == -1 || this.items == null) this.selected = null;
    else this.selected = this.items[this.currentId];
  }
  public moveBack(){
    if (this.items && this.items.length > 0 && this.currentId > 0)this.currentId--;
  }
  public moveNext(){
    if (this.items && this.items.length > this.currentId +1)this.currentId++;
  }

  public get canMoveNext(){
    return this.items && this.items.length > this.currentId +1;
  }
  public get canMoveBack(){
    return this.items && this.items.length > 0 && this.currentId > 0;
  }
  public isTouchStarted: boolean  = false;
  public startPosition: number = 0;
  public offset: number = 0;
  public onTouchStart(e: any){
    if (this.isTouchStarted == false){
      this.isTouchStarted = true;
      this.startPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      console.log('touch started');
    }
  }
  public onTouchMove(e: any){
    if (this.isTouchStarted){
      var currentPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      this.offset = currentPosition - this.startPosition;
      if (this.offset > 0 && this.canMoveBack == false) this.offset = 0;
      else if (this.offset < 0 && this.canMoveNext == false) this.offset = 0;
      console.log('touch moved');
    }
  }  
  public onTouchEnd(e: any){
    if (this.isTouchStarted){
      var currentPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      if (currentPosition - this.startPosition > 80 && this.canMoveBack) this.currentId -=1;
      else if (currentPosition - this.startPosition < -80 && this.canMoveNext) this.currentId +=1;
      
      this.isTouchStarted = false;
      this.offset = 0;
      console.log('touch ended {0}->{1}', this.startPosition,currentPosition);      
    }
  }  
}
